/* eslint-disable */
import * as util from "@/api/binance";

const milliseconds = new Date().getTime();

const state = {
    klineData: [],
    balancesData: [],
    coinList: [
        { id: 'btcusdt', title: 'BTC/USDT', base_asset: "BTC", quote_asset: "USDT" },
        { id: 'ethusdt', title: 'ETH/USDT', base_asset: "ETH", quote_asset: "USDT" },
        { id: 'adausdt', title: 'ADA/USDT', base_asset: "ADA", quote_asset: "USDT" },
        { id: 'atomusdt', title: 'ATOM/USDT', base_asset: "ATOM", quote_asset: "USDT" },
        { id: 'shibusdt', title: 'SHIB/USDT', base_asset: "SHIB", quote_asset: "USDT" },
        { id: 'manausdt', title: 'MANA/USDT', base_asset: "MANA", quote_asset: "USDT" },
        { id: 'atausdt', title: 'ATA/USDT', base_asset: "ATA", quote_asset: "USDT" },
        { id: 'algousdt', title: 'ALGO/USDT', base_asset: "ALGO", quote_asset: "USDT" },
        { id: 'omgusdt', title: 'OMG/USDT', base_asset: "OMG", quote_asset: "USDT" },
        { id: 'linkusdt', title: 'LINK/USDT', base_asset: "LINK", quote_asset: "USDT" },
        { id: 'avaxusdt', title: 'AVAX/USDT', base_asset: "AVAX", quote_asset: "USDT" },
    ],
    // candleStickData: [
    //     {
    //         x: new Date(milliseconds),
    //         y: [0, 0, 0, 0]
    //     },
    // ],
    candleStickData: [
        // {
        //     x: new Date(1538778600000),
        //     y: [6629.81, 6650.5, 6623.04, 6633.33]
        // },
        // {
        //     x: new Date(1538780400000),
        //     y: [6632.01, 6643.59, 6620, 6630.11]
        // }
    ],
};


const mutations = {
    SET_balancesData: (state, value) => {
        state.balancesData = value
    },
    SET_klineData: (state, value) => {
        state.klineData = value
    },
    SET_candleStickData: (state, value) => {
        state.candleStickData = value
    },

};

const actions = {
    actBalancesData({ commit }, data) {
        commit('SET_balancesData', data)
    },
    actKlineData({ commit }, data) {
        commit('SET_klineData', data)
    },
    actCandleStickData({ commit }, data) {
        // console.log("data", data)
        commit('SET_candleStickData', data)
    },
    GetAccount({ commit }) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.GetAccount().then(response => {
                const { data } = response;
                let balances = data.balances
                commit("SET_balancesData", balances)
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    ListOpenOrders({ commit }, symbol) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.ListOpenOrders(symbol).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    ListOrders({ commit }, data) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.ListOrders(data).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    CreateOrders({ commit }, data) {
        // console.log(dataParams)
        return new Promise((resolve, reject) => {
            util.CreateOrders(data).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/binance.js